import { unauthorizedBackendApi } from '@app/services'

import { FetchTokenByHashResponse } from './types'

export const getTokenByHash = async (urlTokenHash: string) => {
  try {
    const { data } =
      await unauthorizedBackendApi.post<FetchTokenByHashResponse>(
        '/users/token',
        null,
        {
          params: {
            hash: urlTokenHash,
          },
        }
      )
    return data?.access_token
  } catch (error) {
    console.error('Error getting token by hash:', error)

    throw error
  }
}
